/**
 * PROGRAM DEGISIKLIK TALEBI — F-SCH-11
 *
 * ================================================================
 * ESIK NEDEN BURADA
 * ================================================================
 * Bu sayi ONCE sunucuda (`degisiklik-hakki.ts`) sabitti ve ogrenci
 * ekranina ELLE kopyalanmisti — kopya 15, aslı 20 yazilmisti.
 *
 * Sonucu su olurdu: ogrenci 15 karakter yazar, "Gönder" dugmesi
 * ACILIR, sunucu 400 doner ve ekranda "en az 20 karakter olmalı"
 * yazar. Yani ekran once izin verip sonra reddeden bir sey olurdu —
 * kullanicinin gozunde rastgele bozukluk.
 *
 * Artik tek yerden geliyor: sunucu da ekran da bunu iceri aliyor,
 * degistirmek isteyen tek satir degistiriyor ve iki taraf birden
 * yeniden derleniyor.
 */

/**
 * Degisiklik gerekcesinin en az uzunlugu.
 *
 * Sebep pedagojik, teknik degil: "programi degistir" talebi uzmanla
 * ogrenci arasindaki konusmanin baslangici. Tek kelimelik bir gerekce
 * uzmanin neyi neden degistirecegini anlamasina yetmez.
 */
export const EN_AZ_GEREKCE = 20;

/** Ogrencinin secebilecegi degisiklik sebepleri — `ChangeReason` ile ayni sira. */
export const DEGISIKLIK_NEDENLERI = [
  "SCHOOL_LOAD",
  "HEALTH",
  "FAMILY",
  "DID_NOT_UNDERSTAND",
  "RESOURCE_ISSUE",
  "TOO_HEAVY",
  "TOO_LIGHT",
  "OTHER",
] as const;

export type DegisiklikNedeni = (typeof DEGISIKLIK_NEDENLERI)[number];
